import { render } from "./LevelModelsPage.vue?vue&type=template&id=3989578e&scoped=true"
import script from "./LevelModelsPage.vue?vue&type=script&lang=js"
export * from "./LevelModelsPage.vue?vue&type=script&lang=js"

import "./LevelModelsPage.vue?vue&type=style&index=0&id=3989578e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3989578e"]])

export default __exports__